export type SearchCardTreatment = (typeof SearchCardTreatment)[keyof typeof SearchCardTreatment];

export const SearchCardTreatment = {
  legacy: 'legacy',
  simplified: 'v2_base',
  legacyApps: 'legacy_apps',
  simplifiedApps: 'v1_base_apps',
} as const;
